import type { CSSObject } from "type/tss";
import { Theme } from "@mui/material/styles";

export const styles = (theme: Theme) => {
	return ({
		block: {
			position: "relative",
			"& pre": {
				minHeight: 50, // prevent copy button overflow
			},
		},
		codeBlockCopy : {
			position: "absolute", 
			right: 0, 
			bottom: 0,
			margin: 8,
		},
		codeBlockCopyIcon: {
			marginLeft: 5,
		},
		// Refreshed look (MAX-4419, Figma VPLAT 20 / OSEO 4).
		refreshedBlock: {
			display: "flex",
			flexDirection: "column",
			alignItems: "flex-start",
			gap: theme.spacing(2),
			padding: theme.spacing(2),
			borderRadius: 8,
			backgroundColor: theme.palette.custom.tableHeaderSurface,
			overflowX: "auto",
			// Plain text as in the Figma: the highlighter emits classes only (useInlineStyles off).
			"& pre": {
				margin: 0,
				padding: 0,
				background: "transparent",
			},
			"& pre, & code": {
				fontFamily: '"Roboto Mono", monospace',
				fontSize: 18,
				lineHeight: "32px",
				color: theme.palette.custom.textPrimary,
			},
		},
		// The disabled state's stand-in for the code: same face as the code, in the muted text colour.
		refreshedPlaceholder: {
			// Doubled so it outranks the block's own `& pre` colour.
			"&&": {
				color: theme.palette.text.secondary,
			},
			margin: 0,
			fontFamily: '"Roboto Mono", monospace',
			fontSize: 18,
			lineHeight: "32px",
			whiteSpace: "pre-wrap",
		},
		refreshedCopy: {
			padding: 0,
			minWidth: 0,
			"& .MuiButton-startIcon": {
				marginLeft: 0,
				marginRight: theme.spacing(0.5),
			},
		},
	} satisfies Record<string, CSSObject>)
}
